var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagneticCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_196_1871",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_196_1871",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB5klEQVR4nO2cu02dQRSEbwTFYPdBA0jskVtw6h0iVwACC3Bu7SGgACKgCUwhPEIQaIkQgSV81xov9/ukKWBnzuPXH5zFAgAAAAAAAAAAAAAA4A21xeea5UAtfivLvTKeVlvl/sWLFvs7v758+mcF8/Vsc10tjmuWR/+j479U96a2OPp+urU23Pya5dL9QM2iFhdDQ6hZftoflbOpHI6c+YydfHcXPHw72d4YUf0H/mqKSVX2RgRw7X9ITKma5Wr5AFrcuR+iaVVulw7A/4iYWgSQBGCvQtEBfiM06wgCAAAAAAAAAIDVwf0zS5OLAJIA7FUoOsBvhBhBfjNkEDsgCcBehaID/EaIEeQ3QwaxA5IA7FUoOsBvhBhBfjNkEDsgCcBehaID/EaIEeQ3QwaxA5IA7FUoOsBvhBhBfjNkEDsgCcBehaID/EaIEeQ3QwaxA5IA7FUoOsBvhBhBfjNkEDsgCcBehaID/EZo1hHEwab4a/NrlpvlA+Bk2ZP1ZFm/COtuY02q2mJ36QD6Od5+gtH9GK3q2cpOP8drf1BOphY/FqPoZ3j7OV77o3IO1Sznw+9Hv4SQ5ZBxFH+q+ode+cPNf02fa/0ibN/wfKJGX7R33YvuybCZDwAAAAAAAAAAAAAAi4/EM939mL4wUgTqAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagneticCard);
export default __webpack_public_path__ + "static/media/Magnetic Card.f9c643da70c0ff309a44eea64601dfb9.svg";
export { ForwardRef as ReactComponent };